export enum SkuAge {
  _6to12Months = "6 to 12 Months",
  _12to15Months = "12 to 15 Months",
  _15to24Months = "15 to 24 Months",
  _above24Months = "> 24 Months",
}
